import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. Solo seguir el protocolo paso a paso. Está diseñado para cualquier persona.'
}, {
  q: '¿Cuánto tiempo toma?',
  a: 'Solo 5 minutos al día. La consistencia es lo que reentrena el cuerpo.'
}, {
  q: '¿Cuándo puedo notar resultados?',
  a: 'Muchas mujeres reportan alivio desde el primer uso. Otras notan cambios graduales en los primeros días.'
}, {
  q: '¿Y si tengo ansiedad clínica o diagnóstico?',
  a: 'Este protocolo no reemplaza tratamiento médico. Es una herramienta fisiológica complementaria que muchas mujeres usan junto con terapia o medicación.'
}, {
  q: '¿Y si no siento nada la primera vez?',
  a: 'El sistema nervioso aprende por repetición, no por intensidad. Algunas personas necesitan unos días de práctica diaria.'
}, {
  q: '¿Cuánto dura el acceso?',
  a: 'Es tuyo de por vida. Sin pagos recurrentes.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-[#FAF5EF] px-4" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gray-900 mb-12" data-id="element-53">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-54">
          {FAQS.map((faq, i) => <div key={i} className="bg-white rounded-2xl border border-[#C06B6B]/10 shadow-sm overflow-hidden" data-id="element-55">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left gap-4" data-id="element-56">
                <span className="text-lg font-bold text-gray-900" data-id="element-57">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.25
            }} className="flex-shrink-0" data-id="element-58">
                  <ChevronDown className="h-5 w-5 text-[#C4973B]" data-id="element-59" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-60">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-61">
                    <div className="px-6 pb-6 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-62">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}